import { useCallback, useEffect, useState } from 'react'
import type { Skill } from '@saip/backend'
import { useBackend } from './context'

export interface UseSkills {
  skills: Skill[]
  loading: boolean
  toggle: (id: string, enabled: boolean) => Promise<void>
  reload: () => Promise<void>
}

export function useSkills(): UseSkills {
  const backend = useBackend()
  const [skills, setSkills] = useState<Skill[]>([])
  const [loading, setLoading] = useState(true)

  const reload = useCallback(async () => {
    setLoading(true)
    try {
      setSkills(await backend.skills.list())
    } finally {
      setLoading(false)
    }
  }, [backend])

  useEffect(() => {
    void reload()
  }, [reload])

  const toggle = useCallback(
    async (id: string, enabled: boolean) => {
      const updated = await backend.skills.setEnabled(id, enabled)
      setSkills((prev) => prev.map((s) => (s.id === id ? updated : s)))
    },
    [backend],
  )

  return { skills, loading, toggle, reload }
}
